import { useState } from 'react'
import Sidebar from './Sidebar'
import Clients from './Clients'
import Payments from './Payments'
import Locations from './Locations'
import Methods from './Methods'
import Reports from './Reports'

const Panel = () => {
  const [content, setContent] = useState<string>('clients')
  return (
    <>
      <div className='grid grid-cols-5'>
        <Sidebar setContent={setContent} />
        {(() => {
          switch (content) {
            case 'clients':
              return (
                <div className='col-span-4'>
                  <Clients />
                </div>
              )

            case 'payments':
              return (
                <div className='col-span-4'>
                  <Payments />
                </div>
              )

            case 'locations':
              return (
                <div className='col-span-4'>
                  <Locations />
                </div>
              )

            case 'methods':
              return (
                <div className='col-span-4'>
                  <Methods />
                </div>
              )

            case 'reports':
              return (
                <div className='col-span-4'>
                  <Reports />
                </div>
              )
          }
        })()}
      </div>
    </>
  )
}

export default Panel
